module.exports = __webpack_public_path__ + "img/banner_correct_text.3470f57b.svg";